const normalizeBaseUrl = (url, fallback) => {
  const resolved = String(url || fallback).trim();
  return resolved.replace(/\/+$/, "");
};

export const API_ORIGIN = normalizeBaseUrl(
  process.env.REACT_APP_API_URL,
  "http://localhost:3001"
);

export const API_BASE = `${API_ORIGIN}/api`;
export const SOCKET_URL = normalizeBaseUrl(
  process.env.REACT_APP_SOCKET_URL,
  API_ORIGIN
);
